/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2026
 */

/**
 * Dashboard card descriptors for the IPSAT 2.0 archetype report.
 *
 * Each Dive Deeper card has:
 *   - A descriptor (title + short blurb) shown on the card itself.
 *   - A modal that opens on "Learn more" and pulls data from one of:
 *       a) the v1.0 archetype content library
 *          (archetypeReport.content.primary, loaded from
 *          content-package/archetypes/<archetype>.json on the backend), or
 *       b) the AI personalization output (archetypeReport.aiContent.*)
 *          generated at /purchase time per Steve's prompt framework.
 *
 * Source per card:
 *
 *   dynamic_operating_pattern   → primary.dynamic_pattern
 *   integrated_insights         → AI (Prompt 3)
 *   disclosure_feedback_loop    → primary.disclosure_prompts
 *                                 (replaced counterintuitive_insights on
 *                                  the dashboard per Steve 2026-06-11;
 *                                  counterintuitive was then pulled from
 *                                  the printable report too on 2026-08-15,
 *                                  so it renders nowhere as of 2.0 launch)
 *   development_focus           → primary.development_focus + optional AI (Prompt 4)
 *   archetype_interfaces        → primary.archetype_interactions
 *   identity_statements         → user's statements + AI (Prompt 2) lens
 */

export interface DashboardCardDescriptor {
  id: DashboardCardId;
  title: string;
  description: string;
}

export type DashboardCardId =
  | 'dynamic_operating_pattern'
  | 'integrated_insights'
  | 'disclosure_feedback_loop'
  | 'development_focus'
  | 'archetype_interfaces'
  | 'identity_statements';

export const DASHBOARD_CARDS: DashboardCardDescriptor[] = [
  {
    id: 'dynamic_operating_pattern',
    title: 'Your Dynamic Operating Pattern',
    description:
      'What motivates you, how you deal with stress, respond to conflict, and ideal projects.',
  },
  {
    id: 'integrated_insights',
    title: 'Integrated Insights',
    description: 'How your internal wiring translates into real world influence.',
  },
  {
    id: 'disclosure_feedback_loop',
    title: 'Disclosure & Feedback Loop',
    description:
      'Turn self-awareness into growth through intentional conversations and honest feedback.',
  },
  {
    id: 'development_focus',
    title: 'Reflect & Apply',
    description: 'Guiding questions for reflection and growth moving forward.',
  },
  {
    id: 'archetype_interfaces',
    title: 'How Your Archetype Interfaces with the Other Five',
    description:
      'Understanding how your Archetype interacts with the other five helps you balance empathy with execution and creativity with consistency.',
  },
  {
    id: 'identity_statements',
    title: 'Your Identity Statements (with Archetype Lens)',
    description:
      'Your five self-authored statements viewed through the lens of your Archetype pattern.',
  },
];
